export default "__VITE_ASSET__MCZK8spD__"